// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rgD3","label":"styles_label__1IQrc"};